import React, { useMemo, useState, useEffect, useRef, useCallback } from 'react';
import { Card, Table, Badge, Button, Form, Row, Col, Alert, Spinner, Toast, ToastContainer, Pagination, Tabs, Tab, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import ClientHistoryModal from '../../components/Modals/ClientHistoryModal';
import WinBackStatsModal from '../../components/Modals/WinBackStatsModal';
import CreateCampaignModal from '../../components/Modals/CreateCampaignModal';
import AnalyticsTab from '../../components/Tabs/AnalyticsTab';
import WinBackDashboard from '../../components/WinBackDashboard/WinBackDashboard';
import FiltrosClientes from '../../components/FiltrosClientes/FiltrosClientes';
import WinBackKPIs from '../../components/WinBackKPIs/WinBackKPIs';
import WinBackExecutivo from '../../components/WinBackExecutivo/WinBackExecutivo';
import LifecyclePanel from '../../components/LifecyclePanel/LifecyclePanel';
import MessageTemplates from '../../components/MessageTemplates/MessageTemplates';
import ConversionTracker from '../../components/ConversionTracker/ConversionTracker';
import DistribuirClientes from '../../components/DistribuirClientes/DistribuirClientes';
import LinkGenerator, { LinksRastreaveis } from '../../components/LinkGenerator/LinkGenerator';
import { FunilFeedback, ListaPendentes } from '../../components/FunilFeedback';
import { fetchClientesInativos, fetchClientesInativosLojaFisica, fetchHistoricoCliente, fetchWinBackStats, fetchCampaigns, deleteCampaign, sendInstantWhatsApp, sendWinBackEmail } from '../../services/api';
import { saveCatalogState, getCatalogState, clearCatalogState } from '../../hooks/useCatalogState';
// WhatsApp sub-components integrados
import { InboxTab, CampanhasTab as WACampanhasTab, TemplatesTab, OptOutTab, getAuthHeaders } from '../WhatsApp/WhatsAppPage';
import waStyles from '../WhatsApp/WhatsAppPage.module.css';


const ClientesInativos = () => {
    const isInitialized = useRef(false);
    const [clientes, setClientes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [diasInativos, setDiasInativos] = useState(60);
    const [error, setError] = useState(null);

    // Estados para filtro de período personalizado
    const [tipoFiltro, setTipoFiltro] = useState('preset'); // 'preset' ou 'custom'
    const [dataInicio, setDataInicio] = useState('');
    const [dataFim, setDataFim] = useState('');
    const [activeShortcut, setActiveShortcut] = useState(''); // Rastreia qual atalho está ativo

    // Modo de exibição: 'todos' | 'com_pedido' | 'sem_pedido'
    const [modoCliente, setModoCliente] = useState('todos');

    // Origem dos dados: 'ecommerce' | 'centro' | 'caxias'
    const [origemDados, setOrigemDados] = useState('ecommerce');

    // Estados para filtros adicionais
    const [filtroValorMin, setFiltroValorMin] = useState(''); // Valor mínimo gasto
    const [filtroValorMax, setFiltroValorMax] = useState(''); // Valor máximo gasto
    const [filtroEstado, setFiltroEstado] = useState(''); // Estado (UF) selecionado
    const [filtroCpf, setFiltroCpf] = useState(''); // Busca por CPF/CNPJ

    // Modal de pedidos do cliente
    const [showPedidosModal, setShowPedidosModal] = useState(false);
    const [pedidosModalData, setPedidosModalData] = useState(null);
    const [pedidosModalLoading, setPedidosModalLoading] = useState(false);
    const [pedidosModalNome, setPedidosModalNome] = useState('');
    const [expandedPedido, setExpandedPedido] = useState(null);

    const aplicarFiltroIntervalo = (diasMin, diasMax, label) => {
        const hoje = new Date();

        // Data Fim = Hoje - diasMin (A data mais recente permitida para a compra)
        // Ex: 30 dias atrás. Se comprou há 29 dias (data > fim), não entra.
        const fim = new Date(hoje);
        fim.setDate(hoje.getDate() - diasMin);

        // Data Inicio = Hoje - diasMax (A data mais antiga permitida)
        // Ex: 60 dias atrás. Se comprou há 61 dias (data < inicio), não entra.
        const inicio = new Date(hoje);
        inicio.setDate(hoje.getDate() - diasMax);

        setDataInicio(inicio.toISOString().split('T')[0]);
        setDataFim(fim.toISOString().split('T')[0]);
        setTipoFiltro('custom');
        setActiveShortcut(label);
        setDiasInativos(diasMin); // Apenas para referência visual se precisar
    };

    const [filtro, setFiltro] = useState('');
    const [sortField, setSortField] = useState('dias_sem_comprar');
    const [sortOrder, setSortOrder] = useState('desc');
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(100);
    const [ultimaBusca, setUltimaBusca] = useState(null);

    const [toastState, setToastState] = useState({ show: false, message: '', bg: 'success' });

    // Estados para o modal de histórico
    const [showModal, setShowModal] = useState(false);
    const [selectedCliente, setSelectedCliente] = useState(null);
    const [historico, setHistorico] = useState(null);
    const [loadingHistorico, setLoadingHistorico] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [showSelectedOnly, setShowSelectedOnly] = useState(false);

    // Estados para stats win-back
    const [showStatsModal, setShowStatsModal] = useState(false);
    const [statsData, setStatsData] = useState(null);
    const [loadingStats, setLoadingStats] = useState(false);

    const [showCreateCampaignModal, setShowCreateCampaignModal] = useState(false);

    // Estados para Templates de Mensagem
    const [showTemplatesModal, setShowTemplatesModal] = useState(false);
    const [templateCliente, setTemplateCliente] = useState(null);

    // Estado para filtro por segmento
    const [segmentoAtivo, setSegmentoAtivo] = useState(null);
    const [clientesSegmento, setClientesSegmento] = useState([]);

    // Estado para modal de distribuição
    const [showDistribuirModal, setShowDistribuirModal] = useState(false);

    // Estado para modal de geração de link
    const [showLinkModal, setShowLinkModal] = useState(false);
    const [clienteParaLink, setClienteParaLink] = useState(null);

    // Modal de exportação CSV com seleção de colunas
    const [showExportModal, setShowExportModal] = useState(false);
    const [exportMode, setExportMode] = useState('todos'); // 'todos' ou 'selecionados'
    const [exportColunas, setExportColunas] = useState({
        cliente: true,
        telefone: true,
        email: true,
        dias_sem_comprar: true,
        cidade_uf: true,
        ultima_compra: true,
        total_gasto: true,
        pedidos: true
    });

    const [activeTab, setActiveTab] = useState('recuperacao');
    const [campanhas, setCampanhas] = useState([]);
    const [loadingCampanhas, setLoadingCampanhas] = useState(false);
    const [showDeleteCampaignModal, setShowDeleteCampaignModal] = useState(false);
    const [campaignToDelete, setCampaignToDelete] = useState(null);
    const [deletingCampaign, setDeletingCampaign] = useState(false);
    const [sendingWhatsApp, setSendingWhatsApp] = useState(null); // contato_id do cliente sendo enviado
    const [showWhatsAppModal, setShowWhatsAppModal] = useState(false);
    const [whatsAppForm, setWhatsAppForm] = useState({ telefone: '', mensagem: '', contato_nome: '' });

    // Email Win-Back states
    const [showEmailModal, setShowEmailModal] = useState(false);
    const [sendingEmail, setSendingEmail] = useState(false);
    const [emailPreview, setEmailPreview] = useState(false);
    const [emailForm, setEmailForm] = useState({
        remetente: 'gringao@lojagringao.com.br',
        senhaApp: '',
        destinatario: '',
        assunto: '',
        htmlBody: ''
    });
    const [emailLayout, setEmailLayout] = useState('novidades');
    const [emailProdutos, setEmailProdutos] = useState([
        { nome: 'Anel Importado de Aço Inox Solitário', imagem: '', link: 'https://lojagringao.com.br/novidades' },
        { nome: 'Bracelete de Aço Inox Prego', imagem: '', link: 'https://lojagringao.com.br/novidades' },
        { nome: 'Colar de Aço Inox Dog Tag', imagem: '', link: 'https://lojagringao.com.br/novidades' },
        { nome: 'Choker de Aço Inox Serpente', imagem: '', link: 'https://lojagringao.com.br/novidades' },
    ]);

    const LOGO_URL = 'https://images.tcdn.com.br/img/img_prod/870793/1604929031_logopreta.png';

    const EMAIL_LAYOUTS = {
        novidades: { label: '🛍️ Novidades da Semana', desc: 'Grid 2x2 com fotos de produtos', assunto: (n) => `✨ Novidades da Semana, ${n}! Confira os lançamentos` },
        destaque: { label: '💎 Produto Destaque', desc: '1 produto em destaque grande', assunto: (n) => `💎 ${n}, temos algo especial para você!` },
        promocao: { label: '🔥 Promoção Especial', desc: 'Banner + produtos em lista', assunto: (n) => `🔥 Promoção exclusiva para você, ${n}!` },
        winback: { label: '👋 Saudade (Win-Back)', desc: 'Reconquista com produto favorito', assunto: (n) => `Sentimos sua falta, ${n}! 🎁 Ofertas especiais para você` },
    };

    // Gerar HTML do email baseado no layout selecionado
    const gerarHtmlTemplate = (layout, firstName, link, produtos) => {
        const produtoImg = (p, size = '250x250') => p.imagem || `https://via.placeholder.com/${size}?text=${encodeURIComponent(p.nome.substring(0, 20))}`;

        const footer = `
    <div style="background: #f4f4f4; padding: 20px; text-align: center; font-size: 12px; color: #777777;">
        <p style="margin:0 0 4px;">Loja Gringão — Atacado de joias de aço inox</p>
        <p style="margin:0 0 4px;">Rua da Alfândega, 353 — Rio de Janeiro/RJ</p>
        <p style="margin:0 0 4px;">WhatsApp: (21) 98246-1826 | <a href="mailto:contatogringaoatacadao@gmail.com" style="color:#000;text-decoration:none;">contatogringaoatacadao@gmail.com</a></p>
        <p style="margin:8px 0 0;">&copy; 2026 Loja Gringão. Todos os direitos reservados.</p>
    </div>`;

        if (layout === 'novidades') {
            return `<!DOCTYPE html>
<html lang="pt-BR"><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1.0"></head>
<body style="margin:0;padding:0;font-family:Arial,sans-serif;background:#f4f4f4;">
<div style="max-width:600px;margin:20px auto;background:#fff;border-radius:8px;overflow:hidden;box-shadow:0 4px 10px rgba(0,0,0,0.1);">
    <div style="background:linear-gradient(135deg,#1a1a2e 0%,#16213e 100%);padding:30px 20px;text-align:center;">
        <img src="${LOGO_URL}" alt="Loja Gringão" style="display:block;margin:0 auto;max-width:180px;">
        <p style="color:#e0e0e0;margin:10px 0 0;font-size:14px;">✨ Novidades da Semana</p>
    </div>
    <div style="padding:40px 30px;text-align:center;color:#333;">
        <h1 style="font-size:24px;margin-bottom:20px;color:#1a1a2e;">Novidades da Semana!</h1>
        <p style="font-size:16px;line-height:1.6;margin-bottom:30px;">Olá <strong>${firstName}</strong>! Acabaram de chegar novas peças em nossa loja. Confira os lançamentos que são tendência e vão encantar seus clientes!</p>
        <div style="display:flex;flex-wrap:wrap;justify-content:space-between;margin-bottom:30px;">
${produtos.map(p => `            <div style="width:48%;margin-bottom:20px;text-align:center;border:1px solid #f0f0f0;padding:10px;border-radius:5px;">
                <img src="${produtoImg(p)}" alt="${p.nome}" style="display:block;margin:0 auto;max-width:100%;border-radius:5px;margin-bottom:10px;">
                <h3 style="font-size:14px;margin:10px 0;color:#333;">${p.nome}</h3>
                <a href="${p.link}" style="color:#1a1a2e;font-size:12px;font-weight:bold;text-decoration:none;">VER PRODUTO →</a>
            </div>`).join('\n')}
        </div>
        <a href="${link}" style="display:inline-block;padding:15px 30px;background:#1a1a2e;color:#fff;text-decoration:none;font-weight:bold;border-radius:5px;">VER TODAS AS NOVIDADES</a>
    </div>
    ${footer}
</div></body></html>`;
        }

        if (layout === 'destaque') {
            const p = produtos[0] || { nome: 'Produto Destaque', imagem: '', link: 'https://lojagringao.com.br' };
            return `<!DOCTYPE html>
<html lang="pt-BR"><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1.0"></head>
<body style="margin:0;padding:0;font-family:Arial,sans-serif;background:#f4f4f4;">
<div style="max-width:600px;margin:20px auto;background:#fff;border-radius:8px;overflow:hidden;box-shadow:0 4px 10px rgba(0,0,0,0.1);">
    <div style="background:linear-gradient(135deg,#1a1a2e 0%,#16213e 100%);padding:30px 20px;text-align:center;">
        <img src="${LOGO_URL}" alt="Loja Gringão" style="display:block;margin:0 auto;max-width:180px;">
        <p style="color:#e0e0e0;margin:10px 0 0;font-size:14px;">💎 Destaque Especial</p>
    </div>
    <div style="padding:40px 30px;text-align:center;color:#333;">
        <h1 style="font-size:24px;margin-bottom:10px;color:#1a1a2e;">Produto em Destaque</h1>
        <p style="font-size:16px;line-height:1.6;margin-bottom:30px;">Olá <strong>${firstName}</strong>! Separamos um produto incrível que combina perfeitamente com o estilo dos seus clientes.</p>
        <div style="border:2px solid #1a1a2e;border-radius:12px;padding:20px;margin-bottom:30px;background:#f0f4ff;">
            <img src="${produtoImg(p, '400x400')}" alt="${p.nome}" style="display:block;margin:0 auto;max-width:100%;border-radius:8px;margin-bottom:16px;">
            <h2 style="font-size:20px;color:#1a1a2e;margin:10px 0;">${p.nome}</h2>
            <p style="color:#666;font-size:14px;margin-bottom:20px;">Peça exclusiva em aço inox — durabilidade e elegância para revenda</p>
            <a href="${p.link}" style="display:inline-block;padding:14px 40px;background:#1a1a2e;color:#fff;text-decoration:none;font-weight:bold;border-radius:30px;font-size:16px;">VER DETALHES →</a>
        </div>
        <p style="font-size:14px;color:#888;">Confira também outras novidades:<br><a href="${link}" style="color:#1a1a2e;font-weight:bold;">www.lojagringao.com.br</a></p>
    </div>
    ${footer}
</div></body></html>`;
        }

        if (layout === 'promocao') {
            return `<!DOCTYPE html>
<html lang="pt-BR"><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1.0"></head>
<body style="margin:0;padding:0;font-family:Arial,sans-serif;background:#f4f4f4;">
<div style="max-width:600px;margin:20px auto;background:#fff;border-radius:8px;overflow:hidden;box-shadow:0 4px 10px rgba(0,0,0,0.1);">
    <div style="background:linear-gradient(135deg,#1a1a2e 0%,#16213e 100%);padding:40px 20px;text-align:center;">
        <img src="${LOGO_URL}" alt="Loja Gringão" style="display:block;margin:0 auto 16px;max-width:160px;">
        <h1 style="color:#fff;font-size:28px;margin:0;">🔥 PROMOÇÃO ESPECIAL</h1>
        <p style="color:#e0e0e0;font-size:16px;margin:8px 0 0;">Ofertas exclusivas para você, ${firstName}!</p>
    </div>
    <div style="padding:30px;">
        <p style="font-size:16px;line-height:1.6;color:#333;text-align:center;margin-bottom:30px;">Aproveite condições imperdíveis em peças selecionadas. Estoque limitado!</p>
${produtos.map((p, i) => `        <div style="display:flex;align-items:center;border-bottom:1px solid #f0f0f0;padding:16px 0;${i === 0 ? 'border-top:1px solid #f0f0f0;' : ''}">
            <img src="${produtoImg(p, '120x120')}" alt="${p.nome}" style="display:block;width:100px;height:100px;object-fit:cover;border-radius:8px;margin-right:16px;flex-shrink:0;">
            <div style="flex:1;">
                <h3 style="font-size:15px;margin:0 0 6px;color:#333;">${p.nome}</h3>
                <p style="font-size:13px;color:#888;margin:0 0 10px;">Aço inox — alta durabilidade</p>
                <a href="${p.link}" style="color:#1a1a2e;font-size:13px;font-weight:bold;text-decoration:none;">VER OFERTA →</a>
            </div>
        </div>`).join('\n')}
        <div style="text-align:center;margin-top:30px;">
            <a href="${link}" style="display:inline-block;padding:16px 40px;background:#1a1a2e;color:#fff;text-decoration:none;font-weight:bold;border-radius:5px;font-size:16px;">VER TODAS AS OFERTAS</a>
        </div>
    </div>
    ${footer}
</div></body></html>`;
        }

        // layout === 'winback'
        return `<!DOCTYPE html>
<html lang="pt-BR"><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1.0"></head>
<body style="margin:0;padding:0;font-family:Arial,sans-serif;background:#f4f4f4;">
<div style="max-width:600px;margin:20px auto;background:#fff;border-radius:8px;overflow:hidden;box-shadow:0 4px 10px rgba(0,0,0,0.1);">
    <div style="background:linear-gradient(135deg,#1a1a2e 0%,#16213e 100%);padding:30px 20px;text-align:center;">
        <img src="${LOGO_URL}" alt="Loja Gringão" style="display:block;margin:0 auto 12px;max-width:180px;">
        <p style="color:#e0e0e0;margin:0;font-size:14px;">Sentimos sua falta! 💙</p>
    </div>
    <div style="padding:30px 24px;">
        <h2 style="color:#333;font-size:22px;margin:0 0 16px;">Olá ${firstName}! 👋</h2>
        <p style="color:#555;font-size:15px;line-height:1.6;">Faz um tempo que você não aparece por aqui — estão saindo algumas opções que estão saindo muito e podem ser a sua cara. Sem pressão 😊</p>
${produtos[0] && produtos[0].imagem ? `        <div style="text-align:center;margin:24px 0;">
            <img src="${produtos[0].imagem}" alt="${produtos[0].nome}" style="max-width:100%;border-radius:8px;margin-bottom:10px;">
            <p style="font-size:14px;color:#333;font-weight:bold;margin:0;">${produtos[0].nome}</p>
        </div>` : ''}
        <div style="text-align:center;margin:28px 0;">
            <a href="${link}" style="display:inline-block;background:linear-gradient(135deg,#28a745 0%,#218838 100%);color:#fff;text-decoration:none;padding:14px 36px;border-radius:8px;font-size:16px;font-weight:700;">🛒 Ver novidades</a>
        </div>
        <p style="color:#888;font-size:13px;text-align:center;">Ou acesse: <a href="${link}" style="color:#007bff;">www.lojagringao.com.br</a></p>
    </div>
    ${footer}
</div></body></html>`;
    };
    const navigate = useNavigate();

    // ========== WhatsApp Stats & Risk ==========
    const [waStats, setWaStats] = useState({});
    const [waRisk, setWaRisk] = useState(null);

    const fetchWaStats = useCallback(async () => {
        try {
            const res = await fetch('/api/whatsapp/inbox/stats', { headers: getAuthHeaders() });
            const data = await res.json();
            if (data.success) setWaStats(data.data);
        } catch (e) { /* silent */ }
    }, []);

    const fetchWaRisk = useCallback(async () => {
        try {
            const res = await fetch('/api/whatsapp/risk-status', { headers: getAuthHeaders() });
            const data = await res.json();
            if (data.success) setWaRisk(data.data);
        } catch (e) { /* silent */ }
    }, []);

    useEffect(() => {
        fetchWaStats();
        fetchWaRisk();
        const iv = setInterval(() => { fetchWaStats(); fetchWaRisk(); }, 30000);
        return () => clearInterval(iv);
    }, [fetchWaStats, fetchWaRisk]);

    const getRiskColor = () => {
        if (!waRisk) return '#6c757d';
        switch (waRisk.level) {
            case 'high': return '#dc3545';
            case 'elevated': return '#fd7e14';
            default: return '#28a745';
        }
    };

    const getRiskEmoji = () => {
        if (!waRisk) return '⚪';
        switch (waRisk.level) {
            case 'high': return '🔴';
            case 'elevated': return '🟡';
            default: return '🟢';
        }
    };

    const getRiskLabel = () => {
        if (!waRisk) return 'Verificando...';
        switch (waRisk.level) {
            case 'high': return 'Alto Risco — Envios Pausados';
            case 'elevated': return 'Risco Elevado — Volume Reduzido';
            default: return 'Normal';
        }
    };

    // Restaurar estado salvo ao montar
    useEffect(() => {
        if (isInitialized.current) return;
        isInitialized.current = true;

        const savedState = getCatalogState('clientes-inativos');
        if (savedState) {
            if (savedState.diasInativos) setDiasInativos(savedState.diasInativos);
            if (savedState.tipoFiltro) setTipoFiltro(savedState.tipoFiltro);
            if (savedState.dataInicio) setDataInicio(savedState.dataInicio);
            if (savedState.dataFim) setDataFim(savedState.dataFim);
            if (savedState.activeShortcut) setActiveShortcut(savedState.activeShortcut);
            if (savedState.filtro) setFiltro(savedState.filtro);
            if (savedState.sortField) setSortField(savedState.sortField);
            if (savedState.sortOrder) setSortOrder(savedState.sortOrder);
            if (savedState.page) setPage(savedState.page);
            if (savedState.pageSize) setPageSize(savedState.pageSize);
            if (savedState.scrollY) {
                setTimeout(() => window.scrollTo({ top: savedState.scrollY, behavior: 'auto' }), 500);
            }
            clearCatalogState();
        }
    }, []);

    // Salvar estado sempre que filtros mudarem
    useEffect(() => {
        if (!isInitialized.current) return;
        saveCatalogState('clientes-inativos', {
            diasInativos, tipoFiltro, dataInicio, dataFim, activeShortcut,
            filtro, sortField, sortOrder, page, pageSize
        });
    }, [diasInativos, tipoFiltro, dataInicio, dataFim, activeShortcut, filtro, sortField, sortOrder, page, pageSize]);

    const handleShowStats = async () => {
        setShowStatsModal(true);
        setLoadingStats(true);
        try {
            const data = await fetchWinBackStats();
            if (data.success) {
                setStatsData(data);
            }
        } catch (error) {
            console.error('Erro ao carregar stats:', error);
        } finally {
            setLoadingStats(false);
        }
    };

    const carregarCampanhas = async () => {
        setLoadingCampanhas(true);
        try {
            const response = await fetchCampaigns();
            if (response.success) {
                setCampanhas(response.data);
            }
        } catch (error) {
            console.error('Erro ao buscar campanhas:', error);
            setToastState({ show: true, message: 'Erro ao carregar campanhas.', bg: 'danger' });
        } finally {
            setLoadingCampanhas(false);
        }
    };

    const handleDeleteCampaignClick = (campanha) => {
        setCampaignToDelete(campanha);
        setShowDeleteCampaignModal(true);
    };

    const handleConfirmDeleteCampaign = async () => {
        if (!campaignToDelete) return;

        setDeletingCampaign(true);
        try {
            const result = await deleteCampaign(campaignToDelete.id);
            if (result.success) {
                setShowDeleteCampaignModal(false);
                setCampaignToDelete(null);
                setToastState({ show: true, message: 'Campanha cancelada com sucesso!', bg: 'success' });
                carregarCampanhas();
            } else {
                setToastState({ show: true, message: 'Erro ao cancelar campanha.', bg: 'danger' });
            }
        } catch (error) {
            console.error('Erro ao deletar campanha:', error);
            setToastState({ show: true, message: 'Erro ao cancelar campanha.', bg: 'danger' });
        } finally {
            setDeletingCampaign(false);
        }
    };

    useEffect(() => {
        if (activeTab === 'campanhas') {
            carregarCampanhas();
        }
    }, [activeTab]);

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            // Seleciona todos os clientes filtrados atualmente mostrados na paginação ou todos filtrados?
            // User request: "selecionar varios". Vamos permitir selecionar todos da página atual
            const idsPagina = clientesPaginados.map(c => c.contato_id);
            setSelectedIds(prev => {
                const novo = new Set([...prev, ...idsPagina]);
                return Array.from(novo);
            });
        } else {
            // Remove da seleção os da página atual
            const idsPagina = clientesPaginados.map(c => c.contato_id);
            setSelectedIds(prev => prev.filter(id => !idsPagina.includes(id)));
        }
    };

    const handleSelectOne = (id) => {
        setSelectedIds(prev => {
            if (prev.includes(id)) return prev.filter(x => x !== id);
            return [...prev, id];
        });
    };

    // Gerar link direto para lojagringao.com.br com UTM para rastreamento via Google Analytics
    // source: 'whatsapp' | 'email' | 'sms'
    const gerarLinkLoja = (cliente, source = 'whatsapp') => {
        const clienteId = cliente.contato_id || cliente.id || 'unknown';
        const diasSemComprar = cliente.dias_sem_comprar || 0;

        // Extrair nome do produto favorito (primeiro da lista)
        let produtoFavorito = '';
        if (Array.isArray(cliente.produtos_favoritos) && cliente.produtos_favoritos.length > 0) {
            const descricao = cliente.produtos_favoritos[0]?.descricao || '';
            // Limpar e abreviar para URL (máximo 50 chars)
            produtoFavorito = descricao
                .replace(/[^a-zA-Z0-9\s]/g, '')
                .replace(/\s+/g, '_')
                .substring(0, 50)
                .toLowerCase();
        }

        // Parâmetros UTM
        const params = new URLSearchParams({
            utm_source: source,
            utm_medium: 'recuperacao',
            utm_campaign: `winback_${clienteId}`,
            utm_content: produtoFavorito || 'geral',
            utm_term: `${diasSemComprar}dias`
        });

        return `https://www.lojagringao.com.br/?${params.toString()}`;
    };

    const handleWhatsApp = (cliente) => {
        const phone = (cliente.celular || cliente.telefone || '').replace(/\D/g, '');
        if (!phone) return;

        const link = gerarLinkLoja(cliente, 'whatsapp');
        const firstName = (cliente.contato_nome || '').split(' ')[0] || '';

        // Personalizar mensagem com produto favorito se disponível
        let produtoMsg = '';
        if (Array.isArray(cliente.produtos_favoritos) && cliente.produtos_favoritos.length > 0) {
            const produto = cliente.produtos_favoritos[0]?.descricao || '';
            if (produto) {
                produtoMsg = ` Vimos que você gostou de "${produto.substring(0, 40)}${produto.length > 40 ? '...' : ''}"!`;
            }
        }

        const msg = `Olá ${firstName}, tudo bem? Sentimos sua falta!${produtoMsg} Acesse nossa loja com ofertas especiais pra você: ${link}`;

        const url = `https://wa.me/55${phone}?text=${encodeURIComponent(msg)}`;
        window.open(url, '_blank');
        setToastState({ show: true, message: 'WhatsApp aberto!', bg: 'success' });
    };

    // Abrir modal para enviar WhatsApp personalizado
    const handleOpenWhatsAppModal = (cliente) => {
        const phone = (cliente?.celular || cliente?.telefone || '').replace(/\D/g, '');
        const firstName = (cliente?.contato_nome || '').split(' ')[0] || 'Cliente';
        let produtoMsg = '';
        if (cliente && Array.isArray(cliente.produtos_favoritos) && cliente.produtos_favoritos.length > 0) {
            const produto = cliente.produtos_favoritos[0]?.descricao || '';
            if (produto) {
                produtoMsg = ` Vimos que você gostou de "${produto.substring(0, 40)}${produto.length > 40 ? '...' : ''}"!`;
            }
        }
        const link = cliente ? gerarLinkLoja(cliente, 'whatsapp') : '';
        const msg = cliente
            ? `Olá ${firstName}, tudo bem? Sentimos sua falta!${produtoMsg} Acesse nossa loja com ofertas especiais pra você: ${link}`
            : '';

        setWhatsAppForm({
            telefone: phone,
            mensagem: msg,
            contato_nome: cliente?.contato_nome || ''
        });
        setShowWhatsAppModal(true);
    };

    // Enviar mensagem WhatsApp diretamente via API (entrega imediata)
    const handleSendWhatsAppFromModal = async () => {
        const { telefone, mensagem, contato_nome } = whatsAppForm;
        if (!telefone) {
            setToastState({ show: true, message: 'Informe o telefone.', bg: 'warning' });
            return;
        }
        if (!mensagem.trim()) {
            setToastState({ show: true, message: 'Informe a mensagem.', bg: 'warning' });
            return;
        }

        setSendingWhatsApp('modal');
        try {
            const result = await sendInstantWhatsApp(telefone, mensagem, contato_nome);
            if (result.success) {
                setToastState({ show: true, message: `✅ WhatsApp enviado para ${telefone}!`, bg: 'success' });
                setShowWhatsAppModal(false);
            } else {
                setToastState({ show: true, message: `❌ Falha: ${result.message}`, bg: 'danger' });
            }
        } catch (error) {
            setToastState({ show: true, message: `Erro ao enviar: ${error.message}`, bg: 'danger' });
        } finally {
            setSendingWhatsApp(null);
        }
    };

    // Abrir modal de templates com cliente selecionado
    const handleOpenTemplates = (cliente) => {
        setTemplateCliente(cliente);
        setShowTemplatesModal(true);
    };

    // Handler para quando uma mensagem é enviada via template
    const handleTemplateSent = (cliente, mensagem, templateId) => {
        setToastState({ show: true, message: `Mensagem enviada usando template "${templateId}"!`, bg: 'success' });
    };

    // Handler para clique em segmento
    const handleSegmentClick = (segmentName, segmentClientes) => {
        setSegmentoAtivo(segmentName);
        setClientesSegmento(segmentClientes);
        setToastState({
            show: true,
            message: `Filtrado por: ${segmentName} (${segmentClientes.length} clientes)`,
            bg: 'info'
        });
    };

    // Limpar filtro de segmento
    const handleClearSegment = () => {
        setSegmentoAtivo(null);
        setClientesSegmento([]);
    };

    // Abrir modal de email para cliente
    const handleOpenEmailModal = (cliente) => {
        const firstName = (cliente?.contato_nome || '').split(' ')[0] || 'Cliente';
        const link = gerarLinkLoja(cliente, 'email');
        const layout = emailLayout || 'novidades';

        // Se cliente tem produtos favoritos, preencher os nomes
        const prods = [...emailProdutos];
        if (cliente && Array.isArray(cliente.produtos_favoritos) && cliente.produtos_favoritos.length > 0) {
            cliente.produtos_favoritos.forEach((pf, i) => {
                if (i < prods.length && pf?.descricao) {
                    prods[i] = { ...prods[i], nome: pf.descricao };
                }
            });
            setEmailProdutos(prods);
        }

        const assuntoFn = EMAIL_LAYOUTS[layout]?.assunto || EMAIL_LAYOUTS.winback.assunto;
        const htmlTemplate = gerarHtmlTemplate(layout, firstName, link, prods);

        setEmailForm({
            remetente: emailForm.remetente || 'marketing@lojagringao.com.br',
            senhaApp: emailForm.senhaApp || '',
            destinatario: cliente?.email || '',
            assunto: assuntoFn(firstName),
            htmlBody: htmlTemplate
        });
        setEmailPreview(false);
        setShowEmailModal(true);
    };

    // Atualizar HTML quando layout ou produtos mudam (apenas se modal estiver aberto)
    const regenerarEmailHtml = (novoLayout, novosProdutos) => {
        const firstName = (emailForm.assunto.match(/,\s*([^!]+)/) || [])[1]?.trim() || 'Cliente';
        const link = `https://lojagringao.com.br?utm_source=email&utm_medium=winback&utm_campaign=recuperacao`;
        const assuntoFn = EMAIL_LAYOUTS[novoLayout]?.assunto || EMAIL_LAYOUTS.winback.assunto;
        setEmailForm(prev => ({
            ...prev,
            assunto: assuntoFn(firstName),
            htmlBody: gerarHtmlTemplate(novoLayout, firstName, link, novosProdutos || emailProdutos)
        }));
    };

    // Enviar email via backend
    const handleSendEmail = async () => {
        const { remetente, senhaApp, destinatario, assunto, htmlBody } = emailForm;
        if (!destinatario) {
            setToastState({ show: true, message: 'Preencha o email destinatário.', bg: 'warning' });
            return;
        }
        if (!assunto.trim()) {
            setToastState({ show: true, message: 'Preencha o assunto.', bg: 'warning' });
            return;
        }

        setSendingEmail(true);
        try {
            const result = await sendWinBackEmail({ remetente, senhaApp, destinatario, assunto, htmlBody });
            if (result.success) {
                setToastState({ show: true, message: `✅ Email enviado para ${destinatario}!`, bg: 'success' });
                setShowEmailModal(false);
            } else {
                setToastState({ show: true, message: `❌ ${result.message}`, bg: 'danger' });
            }
        } catch (error) {
            setToastState({ show: true, message: `Erro ao enviar: ${error.message}`, bg: 'danger' });
        } finally {
            setSendingEmail(false);
        }
    };

    // Copiar link para email (fallback)
    const handleCopyLinkEmail = (cliente) => {
        const link = gerarLinkLoja(cliente, 'email');
        copiarContato(link);
        setToastState({ show: true, message: 'Link para Email copiado!', bg: 'success' });
    };

    const handleCopyLinkShort = (cliente) => {
        const link = gerarLinkLoja(cliente, 'whatsapp');
        copiarContato(link);
        setToastState({ show: true, message: 'Link WhatsApp copiado!', bg: 'success' });
    };

    const handleExportar = () => {
        setExportMode('selecionados');
        setShowExportModal(true);
    };

    const handleExportarTodos = () => {
        setExportMode('todos');
        setShowExportModal(true);
    };

    const toggleExportColuna = (col) => {
        setExportColunas(prev => ({ ...prev, [col]: !prev[col] }));
    };

    const executarExportCSV = () => {
        const dados = exportMode === 'selecionados'
            ? clientesProcessados.filter(c => selectedIds.includes(c.contato_id))
            : clientesProcessados;
        if (dados.length === 0) return;

        // Mapear colunas selecionadas
        const colunasConfig = [
            { key: 'cliente', header: 'Nome', getValue: c => (c.contato_nome || '').replace(/;/g, ',') },
            { key: 'telefone', header: 'Telefone', getValue: c => c.celular || c.telefone || '' },
            { key: 'email', header: 'Email', getValue: c => c.email || '' },
            { key: 'dias_sem_comprar', header: 'Dias Sem Comprar', getValue: c => c.dias_sem_comprar !== null ? c.dias_sem_comprar : 'Nunca comprou' },
            { key: 'cidade_uf', header: 'Cidade/UF', getValue: c => `${c.cidade || ''}/${c.uf || ''}` },
            { key: 'ultima_compra', header: 'Última Compra', getValue: c => c.ultima_compra ? new Date(c.ultima_compra).toLocaleDateString('pt-BR') : '' },
            { key: 'total_gasto', header: 'Total Gasto', getValue: c => (Number(c.total_gasto) || 0).toFixed(2).replace('.', ',') },
            { key: 'pedidos', header: 'Pedidos', getValue: c => Number(c.total_pedidos_geral) || 0 }
        ];

        const colunasAtivas = colunasConfig.filter(col => exportColunas[col.key]);
        if (colunasAtivas.length === 0) return;

        const headers = colunasAtivas.map(c => c.header);
        const rows = dados.map(c =>
            colunasAtivas.map(col => `"${String(col.getValue(c)).replace(/"/g, '""')}"`).join(';')
        );

        const bom = '\uFEFF';
        const csv = bom + headers.join(';') + '\n' + rows.join('\n');
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        const origem = origemDados === 'centro' ? 'LojaCentro' : origemDados === 'caxias' ? 'LojaCaxias' : 'Ecommerce';
        a.download = `clientes_inativos_${origem}_${new Date().toISOString().slice(0, 10)}.csv`;
        a.click();
        URL.revokeObjectURL(url);
        setShowExportModal(false);
    };

    const carregarDados = async () => {
        setLoading(true);
        setError(null);
        try {
            let response;
            const diParam = tipoFiltro === 'custom' ? dataInicio : '';
            const dfParam = tipoFiltro === 'custom' ? dataFim : '';

            if (origemDados === 'centro' || origemDados === 'caxias') {
                // Buscar clientes inativos da loja física
                response = await fetchClientesInativosLojaFisica(
                    origemDados, diasInativos, 1, 100000, diParam, dfParam, modoCliente
                );
            } else {
                // Buscar clientes inativos do e-commerce
                response = await fetchClientesInativos(
                    diasInativos, 1, 100000, diParam, dfParam, modoCliente
                );
            }

            if (response && response.success) {
                const dados = Array.isArray(response.data) ? response.data : [];
                setClientes(dados);
                setUltimaBusca(new Date());
                setPage(1);
            } else {
                setError('Erro ao carregar dados: ' + (response?.message || 'Resposta inválida do servidor'));
                setClientes([]);
            }
        } catch (err) {
            console.error('Erro ao buscar clientes inativos:', err);
            setError('Erro de conexão ao buscar clientes.');
            setClientes([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // Só recarrega automaticamente se estiver no modo preset
        if (tipoFiltro === 'preset') {
            carregarDados();
        }
        // Se for custom e tiver um atalho ativo com datas definidas, carrega automaticamente
        else if (tipoFiltro === 'custom' && activeShortcut && dataInicio && dataFim) {
            carregarDados();
        }
    }, [diasInativos, tipoFiltro, activeShortcut, dataInicio, dataFim, modoCliente, origemDados]);

    useEffect(() => {
        setPage(1);
    }, [filtro, pageSize, showSelectedOnly]);

    const handleClienteClick = async (cliente) => {
        setSelectedCliente(cliente);
        setShowModal(true);
        setLoadingHistorico(true);
        setHistorico(null);

        try {
            const response = await fetchHistoricoCliente({
                id: cliente.contato_id,
                nome: cliente.contato_nome
            });

            if (response.success) {
                setHistorico(response.data);
            } else {
                setToastState({ show: true, message: response.message || 'Não foi possível carregar o histórico.', bg: 'danger' });
            }
        } catch (error) {
            setToastState({ show: true, message: 'Erro ao buscar histórico do cliente.', bg: 'danger' });
        } finally {
            setLoadingHistorico(false);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedCliente(null);
        setHistorico(null);
    };

    const copiarContato = async (texto) => {
        if (!texto) return;
        try {
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(texto);
            } else {
                const textarea = document.createElement('textarea');
                textarea.value = texto;
                textarea.setAttribute('readonly', '');
                textarea.style.position = 'absolute';
                textarea.style.left = '-9999px';
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand('copy');
                textarea.remove();
            }
            setToastState({ show: true, message: 'Copiado: ' + texto, bg: 'success' });
        } catch (e) {
            setToastState({ show: true, message: 'Não foi possível copiar.', bg: 'danger' });
        }
    };

    // Extrair lista de estados (UF) únicos para o dropdown de filtro
    const estadosDisponiveis = useMemo(() => {
        const clientesArray = Array.isArray(clientes) ? clientes : [];
        const ufsSet = new Set();
        clientesArray.forEach(c => {
            if (c.uf && c.uf.trim()) {
                ufsSet.add(c.uf.trim().toUpperCase());
            }
        });
        return Array.from(ufsSet).sort((a, b) => a.localeCompare(b, 'pt-BR'));
    }, [clientes]);

    const clientesProcessados = useMemo(() => {
        // Se tem segmento ativo, usa os clientes do segmento
        // Senão, usa todos os clientes carregados
        const baseClientes = segmentoAtivo && clientesSegmento.length > 0
            ? clientesSegmento
            : (Array.isArray(clientes) ? clientes : []);

        const termo = (filtro || '').trim().toLowerCase();
        let resultado = [...baseClientes];

        if (showSelectedOnly) {
            resultado = resultado.filter(c => selectedIds.includes(c.contato_id));
        }

        if (termo) {
            resultado = resultado.filter((c) => {
                if (!c) return false;
                const nome = String(c.contato_nome || '').toLowerCase();
                const email = String(c.email || '').toLowerCase();
                const cidade = String(c.cidade || '').toLowerCase();
                
                const celular = String(c.celular || '').replace(/\D/g, '');
                const telefone = String(c.telefone || '').replace(/\D/g, '');
                const cpfCnpj = String(c.cpf_cnpj || '').replace(/\D/g, '');
                const termoLimpo = termo.replace(/\D/g, '');
                
                const matchTexto = nome.includes(termo) || email.includes(termo) || cidade.includes(termo);
                const matchNumero = termoLimpo.length > 0 && (celular.includes(termoLimpo) || telefone.includes(termoLimpo) || cpfCnpj.includes(termoLimpo));
                
                return matchTexto || matchNumero;
            });
        }

        // Filtrar por estado (UF)
        if (filtroEstado) {
            resultado = resultado.filter(c => (c.uf || '').trim().toUpperCase() === filtroEstado.toUpperCase());
        }

        // Filtrar por CPF/CNPJ
        if (filtroCpf) {
            const cpfBusca = filtroCpf.replace(/\D/g, ''); // Remove formatação
            resultado = resultado.filter(c => {
                const cpfCliente = (c.cpf_cnpj || '').replace(/\D/g, '');
                return cpfCliente.includes(cpfBusca);
            });
        }

        // Filtrar por valor gasto mínimo
        if (filtroValorMin !== '') {
            const valorMin = parseFloat(filtroValorMin) || 0;
            resultado = resultado.filter(c => (Number(c.total_gasto) || 0) >= valorMin);
        }

        // Filtrar por valor gasto máximo
        if (filtroValorMax !== '') {
            const valorMax = parseFloat(filtroValorMax) || 0;
            resultado = resultado.filter(c => (Number(c.total_gasto) || 0) <= valorMax);
        }

        resultado.sort((a, b) => {
            if (!a || !b) return 0;
            const order = sortOrder === 'asc' ? 1 : -1;
            switch (sortField) {
                case 'contato_nome': {
                    const av = String(a.contato_nome || '').toLowerCase();
                    const bv = String(b.contato_nome || '').toLowerCase();
                    return av.localeCompare(bv) * order;
                }
                case 'ultima_compra': {
                    const av = a.ultima_compra ? new Date(a.ultima_compra).getTime() : 0;
                    const bv = b.ultima_compra ? new Date(b.ultima_compra).getTime() : 0;
                    return (av - bv) * order;
                }
                case 'total_gasto': {
                    const av = Number(a.total_gasto) || 0;
                    const bv = Number(b.total_gasto) || 0;
                    return (av - bv) * order;
                }
                case 'dias_sem_comprar':
                default: {
                    // Clientes sem compra (null) vão pro final quando desc, pro início quando asc
                    const av = a.dias_sem_comprar !== null ? Number(a.dias_sem_comprar) : (sortOrder === 'desc' ? -1 : 999999);
                    const bv = b.dias_sem_comprar !== null ? Number(b.dias_sem_comprar) : (sortOrder === 'desc' ? -1 : 999999);
                    return (av - bv) * order;
                }
            }
        });

        return resultado;
    }, [clientes, filtro, sortField, sortOrder, showSelectedOnly, selectedIds, filtroEstado, filtroCpf, filtroValorMin, filtroValorMax, segmentoAtivo, clientesSegmento]);

    const stats = useMemo(() => {
        const total = clientesProcessados.length;
        const totalGasto = clientesProcessados.reduce((acc, c) => acc + (Number(c.total_gasto) || 0), 0);
        // Calcular média de dias apenas para clientes que já compraram
        const clientesComCompra = clientesProcessados.filter(c => c.dias_sem_comprar !== null);
        const totalSemCompra = clientesProcessados.filter(c => c.dias_sem_comprar === null).length;
        const mediaDias = clientesComCompra.length
            ? Math.round(clientesComCompra.reduce((acc, c) => acc + (Number(c.dias_sem_comprar) || 0), 0) / clientesComCompra.length)
            : 0;
        return { total, totalGasto, mediaDias, totalSemCompra };
    }, [clientesProcessados]);

    const totalPages = Math.max(1, Math.ceil(clientesProcessados.length / pageSize));
    const pageSafe = Math.min(page, totalPages);
    const startIndex = (pageSafe - 1) * pageSize;
    const clientesPaginados = clientesProcessados.slice(startIndex, startIndex + pageSize);

    const toggleSort = (field) => {
        if (sortField === field) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortOrder('desc');
        }
    };

    const SortIcon = ({ field }) => {
        if (sortField !== field) return <span className="ms-1 text-muted">⇅</span>;
        return <span className="ms-1">{sortOrder === 'asc' ? '↑' : '↓'}</span>;
    };

    return (
        <div className="clientes-inativos-container fade-in">
            {/* WhatsApp Risk Indicator Header */}
            <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'flex-end',
                gap: 16, marginBottom: 16, flexWrap: 'wrap'
            }}>
                <div className={waStyles.statsBar} style={{ marginBottom: 0, flex: 1, minWidth: 300 }}>
                    <div className={`${waStyles.statCard} ${waStyles.statGreen}`}>
                        <div className={waStyles.statValue}>{waStats.totalConversations || 0}</div>
                        <div className={waStyles.statLabel}>Conversas WA</div>
                    </div>
                    <div className={`${waStyles.statCard} ${waStyles.statBlue}`}>
                        <div className={waStyles.statValue}>{waStats.unreadConversations || 0}</div>
                        <div className={waStyles.statLabel}>Não Lidas</div>
                    </div>
                    <div className={`${waStyles.statCard} ${waStyles.statOrange}`}>
                        <div className={waStyles.statValue}>
                            {waRisk ? `${waRisk.dailyCount}/${waRisk.effectiveLimit}` : `${waStats.dailySent || 0}/${waStats.dailyLimit || 200}`}
                        </div>
                        <div className={waStyles.statLabel}>Enviadas Hoje</div>
                    </div>
                    <div className={`${waStyles.statCard} ${waStyles.statRed}`}>
                        <div className={waStyles.statValue}>{waStats.optedOutContacts || 0}</div>
                        <div className={waStyles.statLabel}>Opt-Out</div>
                    </div>
                </div>
                <div style={{
                    display: 'flex', alignItems: 'center', gap: 10,
                    background: `${getRiskColor()}15`, border: `1px solid ${getRiskColor()}40`,
                    padding: '8px 16px', borderRadius: 10, fontSize: '0.85rem'
                }}>
                    <span style={{ fontSize: '1.2rem' }}>{getRiskEmoji()}</span>
                    <div>
                        <div style={{ fontWeight: 700, color: getRiskColor() }}>{getRiskLabel()}</div>
                        {waRisk && (
                            <div style={{ fontSize: '0.75rem', color: '#6c757d', marginTop: 2 }}>
                                {waRisk.dailyCount}/{waRisk.effectiveLimit} msg ·
                                {waRisk.isHardBlocked ? ' ⛔ Fora do horário' : ` 🕐 ${waRisk.brasiliaHour}h BRT`}
                                {waRisk.isPaused && ` · ⏸ Pausado`}
                                {waRisk.volumeReduction > 0 && ` · ↓${waRisk.volumeReduction}% volume`}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <Card className="mb-4">
                <Card.Body>
                    <Tabs
                        activeKey={activeTab}
                        onSelect={(k) => setActiveTab(k)}
                        className="mb-4"
                    >
                        <Tab eventKey="executivo" title="🎯 Prioridade de Contato">
                            <div className="pt-3">
                                <WinBackExecutivo />
                            </div>
                        </Tab>
                        <Tab eventKey="lifecycle" title="🧬 Lifecycle">
                            <div className="pt-3">
                                <LifecyclePanel />
                            </div>
                        </Tab>
                        <Tab eventKey="recuperacao" title="🎣 Recuperação (Win-Back)">
                            <div className="pt-2">
                                <Row className="align-items-center mb-3">
                                    <Col md={6}>
                                        <h5 className="mb-0 text-secondary">
                                            Recuperação de Clientes
                                        </h5>
                                        <small className="text-muted">
                                            {diasInativos === 0
                                                ? 'Todos os clientes cadastrados.'
                                                : `Clientes que compraram no passado mas não compram há mais de ${diasInativos} dias.`
                                            }
                                        </small>
                                    </Col>
                                    <Col md={6} className="text-md-end">
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            className="me-2 mb-2 mb-md-0"
                                            onClick={handleShowStats}
                                        >
                                            Ver Relatório
                                        </Button>
                                    </Col>
                                </Row>

                                {/* Seletor de Origem dos Dados */}
                                <div className="d-flex align-items-center gap-2 mb-3">
                                    <span className="text-muted fw-semibold" style={{ fontSize: '0.85rem' }}>Origem:</span>
                                    <div className="btn-group btn-group-sm">
                                        <Button
                                            variant={origemDados === 'ecommerce' ? 'primary' : 'outline-primary'}
                                            onClick={() => setOrigemDados('ecommerce')}
                                        >
                                            🌐 E-commerce
                                        </Button>
                                        <Button
                                            variant={origemDados === 'centro' ? 'primary' : 'outline-primary'}
                                            onClick={() => setOrigemDados('centro')}
                                        >
                                            🏪 Loja Centro
                                        </Button>
                                        <Button
                                            variant={origemDados === 'caxias' ? 'primary' : 'outline-primary'}
                                            onClick={() => setOrigemDados('caxias')}
                                        >
                                            🏬 Loja Caxias
                                        </Button>
                                    </div>
                                    {loading && <Spinner animation="border" size="sm" className="ms-2" />}
                                </div>

                                {/* Dashboard Visual de KPIs */}
                                <WinBackKPIs
                                    clientes={clientes}
                                    onSegmentClick={handleSegmentClick}
                                />

                                {/* Indicador de Segmento Ativo */}
                                {segmentoAtivo && (
                                    <Alert variant="info" className="d-flex justify-content-between align-items-center">
                                        <span>
                                            🎯 Filtro ativo: <strong>{segmentoAtivo}</strong> ({clientesSegmento.length} clientes)
                                        </span>
                                        <Button variant="outline-info" size="sm" onClick={handleClearSegment}>
                                            ✕ Limpar Filtro
                                        </Button>
                                    </Alert>
                                )}

                                {/* Barra de Filtros Unificada - Estilo E-commerce */}
                                <FiltrosClientes
                                    estadosDisponiveis={estadosDisponiveis}
                                    initialEstado={filtroEstado}
                                    initialCpf={filtroCpf}
                                    initialValorMin={filtroValorMin}
                                    initialValorMax={filtroValorMax}
                                    initialSearch={filtro}
                                    initialOrdenacao={sortField}
                                    initialPageSize={pageSize}
                                    initialDiasInativos={diasInativos}
                                    onSearchChange={setFiltro}
                                    onFilterChange={({ estado, cpf, valorMin, valorMax }) => {
                                        if (estado !== undefined) setFiltroEstado(estado);
                                        if (cpf !== undefined) setFiltroCpf(cpf);
                                        if (valorMin !== undefined) setFiltroValorMin(valorMin);
                                        if (valorMax !== undefined) setFiltroValorMax(valorMax);
                                    }}
                                    onOrdenacaoChange={setSortField}
                                    onPageSizeChange={setPageSize}
                                    onDiasInativosChange={setDiasInativos}
                                    onAtualizar={carregarDados}
                                    loading={loading}
                                />

                                {selectedIds.length > 0 && (
                                    <Row className="mb-3">
                                        <Col>
                                            <Alert variant="info" className="py-2 d-flex justify-content-between align-items-center">
                                                <span>
                                                    <strong>{selectedIds.length}</strong> clientes selecionados.
                                                </span>
                                                <div className="d-flex gap-2">
                                                    <Form.Check
                                                        type="switch"
                                                        id="show-selected-switch"
                                                        label="Mostrar apenas selecionados"
                                                        checked={showSelectedOnly}
                                                        onChange={(e) => setShowSelectedOnly(e.target.checked)}
                                                        className="d-flex align-items-center me-3"
                                                    />
                                                    <Button variant="success" size="sm" onClick={handleExportar}>
                                                        📥 Exportar CSV (Excel)
                                                    </Button>
                                                    <Button variant="primary" size="sm" onClick={() => setShowCreateCampaignModal(true)}>
                                                        🚀 Criar Campanha
                                                    </Button>
                                                    <Button variant="outline-danger" size="sm" onClick={() => setSelectedIds([])}>
                                                        Limpar Seleção
                                                    </Button>
                                                </div>
                                            </Alert>
                                        </Col>
                                    </Row>
                                )}

                                {/* Filtro de Modo + Exportar */}
                                <Row className="mb-3">
                                    <Col>
                                        <div className="d-flex gap-2 align-items-center flex-wrap">
                                            <span className="text-muted small fw-bold me-1">Exibir:</span>
                                            <Button
                                                variant={modoCliente === 'todos' ? 'primary' : 'outline-primary'}
                                                size="sm"
                                                onClick={() => setModoCliente('todos')}
                                            >
                                                👥 Todos
                                            </Button>
                                            <Button
                                                variant={modoCliente === 'com_pedido' ? 'success' : 'outline-success'}
                                                size="sm"
                                                onClick={() => setModoCliente('com_pedido')}
                                            >
                                                🛒 Com compras
                                            </Button>
                                            <Button
                                                variant={modoCliente === 'sem_pedido' ? 'warning' : 'outline-warning'}
                                                size="sm"
                                                onClick={() => setModoCliente('sem_pedido')}
                                            >
                                                🆕 Sem compras
                                            </Button>
                                            {stats.totalSemCompra > 0 && modoCliente === 'todos' && (
                                                <Badge bg="info" className="ms-2">
                                                    {stats.totalSemCompra} nunca compraram
                                                </Badge>
                                            )}
                                            <Button
                                                variant="outline-dark"
                                                size="sm"
                                                className="ms-auto"
                                                disabled={clientesProcessados.length === 0}
                                                onClick={handleExportarTodos}
                                            >
                                                📥 Exportar CSV ({clientesProcessados.length})
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>

                                <Row className="g-2 mb-3">
                                    <Col md={4}>
                                        <Card className="border-0 bg-light">
                                            <Card.Body className="py-2">
                                                <div className="text-muted small">Clientes no resultado</div>
                                                <div className="fw-bold">{stats.total}</div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={4}>
                                        <Card className="border-0 bg-light">
                                            <Card.Body className="py-2">
                                                <div className="text-muted small">Total gasto (resultado)</div>
                                                <div className="fw-bold">
                                                    R$ {stats.totalGasto.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={4}>
                                        <Card className="border-0 bg-light">
                                            <Card.Body className="py-2">
                                                <div className="text-muted small">Média de dias sem comprar</div>
                                                <div className="fw-bold">{stats.mediaDias} dias</div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>

                                {error && <Alert variant="danger">{error}</Alert>}

                                {loading ? (
                                    <div className="text-center py-5">
                                        <Spinner animation="border" variant="primary" />
                                        <p className="mt-2 text-muted">Analisando histórico de vendas...</p>
                                    </div>
                                ) : (
                                    <>
                                        {clientesProcessados.length === 0 ? (
                                            <Alert variant="info" className="text-center">
                                                Nenhum cliente inativo encontrado com esse critério. Que bom! 🎉
                                            </Alert>
                                        ) : (
                                            <div className="table-responsive">
                                                <Table hover className="align-middle table-modern">
                                                    <thead className="bg-light">
                                                        <tr>
                                                            <th style={{ width: '40px' }} className="text-center">
                                                                <Form.Check
                                                                    checked={clientesPaginados.length > 0 && clientesPaginados.every(c => selectedIds.includes(c.contato_id))}
                                                                    onChange={handleSelectAll}
                                                                />
                                                            </th>
                                                            <th style={{ cursor: 'pointer' }} onClick={() => toggleSort('contato_nome')}>
                                                                Cliente <SortIcon field="contato_nome" />
                                                            </th>
                                                            <th>Telefone</th>
                                                            <th>Email</th>
                                                            <th style={{ cursor: 'pointer' }} onClick={() => toggleSort('dias_sem_comprar')}>
                                                                Dias sem comprar <SortIcon field="dias_sem_comprar" />
                                                            </th>
                                                            <th>Cidade/UF</th>
                                                            <th style={{ cursor: 'pointer' }} onClick={() => toggleSort('ultima_compra')}>
                                                                Última compra <SortIcon field="ultima_compra" />
                                                            </th>
                                                            <th style={{ cursor: 'pointer' }} onClick={() => toggleSort('total_gasto')}>
                                                                Total gasto <SortIcon field="total_gasto" />
                                                            </th>
                                                            <th style={{ cursor: 'pointer' }} onClick={() => toggleSort('total_pedidos_geral')}>
                                                                Pedidos <SortIcon field="total_pedidos_geral" />
                                                            </th>
                                                            <th>Ações</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {clientesPaginados.map((cliente, idx) => (
                                                            <tr key={idx} className={selectedIds.includes(cliente.contato_id) ? 'table-primary' : ''}>
                                                                <td className="text-center">
                                                                    <Form.Check
                                                                        checked={selectedIds.includes(cliente.contato_id)}
                                                                        onChange={() => handleSelectOne(cliente.contato_id)}
                                                                    />
                                                                </td>
                                                                <td onClick={() => handleClienteClick(cliente)} style={{ cursor: 'pointer' }}>
                                                                    <div className="fw-bold text-primary">{cliente.contato_nome || '-'}</div>
                                                                </td>
                                                                <td>
                                                                    {(cliente.celular || cliente.telefone) ? (
                                                                        <span
                                                                            className="cursor-pointer"
                                                                            style={{ color: '#25d366', fontWeight: 500, fontSize: '0.85rem' }}
                                                                            title="Copiar Telefone"
                                                                            onClick={() => copiarContato(cliente.celular || cliente.telefone)}
                                                                        >
                                                                            📱 {cliente.celular || cliente.telefone}
                                                                        </span>
                                                                    ) : (
                                                                        <span className="text-muted">-</span>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    {cliente.email ? (
                                                                        <span
                                                                            className="cursor-pointer"
                                                                            style={{ fontSize: '0.85rem' }}
                                                                            title="Copiar Email"
                                                                            onClick={() => copiarContato(cliente.email)}
                                                                        >
                                                                            📧 {cliente.email}
                                                                        </span>
                                                                    ) : (
                                                                        <span className="text-muted">-</span>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    {cliente.dias_sem_comprar !== null ? (
                                                                        <Badge bg="warning" text="dark" className="p-2">
                                                                            {cliente.dias_sem_comprar} dias sem comprar
                                                                        </Badge>
                                                                    ) : (
                                                                        <Badge bg="secondary" className="p-2">
                                                                            Nunca comprou
                                                                        </Badge>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    {cliente.cidade || '-'} / {cliente.uf || '-'}
                                                                </td>
                                                                <td>
                                                                    <div className="fw-bold fs-5 text-dark">
                                                                        {cliente.ultima_compra
                                                                            ? new Date(cliente.ultima_compra).toLocaleDateString('pt-BR')
                                                                            : '—'}
                                                                    </div>
                                                                </td>
                                                                <td className="fw-bold">
                                                                    R$ {(Number(cliente.total_gasto) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                                                </td>
                                                                <td className="text-center">
                                                                    <Badge
                                                                        bg={Number(cliente.total_pedidos_geral) > 0 ? 'primary' : 'secondary'}
                                                                        className="p-2"
                                                                        style={{ cursor: Number(cliente.total_pedidos_geral) > 0 ? 'pointer' : 'default' }}
                                                                        onClick={async () => {
                                                                            if (Number(cliente.total_pedidos_geral) <= 0) return;
                                                                            setPedidosModalNome(cliente.contato_nome || 'Cliente');
                                                                            setPedidosModalLoading(true);
                                                                            setShowPedidosModal(true);
                                                                            setExpandedPedido(null);
                                                                            try {
                                                                                const res = await fetch(`/api/clientes/pedidos-cliente/${cliente.contato_id}?origem=${origemDados}`);
                                                                                const data = await res.json();
                                                                                setPedidosModalData(data);
                                                                            } catch (e) {
                                                                                console.error('Erro ao buscar pedidos:', e);
                                                                                setPedidosModalData({ pedidos: [], total: 0 });
                                                                            }
                                                                            setPedidosModalLoading(false);
                                                                        }}
                                                                        title={Number(cliente.total_pedidos_geral) > 0 ? 'Ver pedidos' : ''}
                                                                    >
                                                                        {Number(cliente.total_pedidos_geral) || 0}
                                                                    </Badge>
                                                                </td>

                                                                <td style={{ whiteSpace: 'nowrap' }}>
                                                                    {(() => {
                                                                        const phone = (cliente.celular || cliente.telefone || '').replace(/\D/g, '');
                                                                        return (
                                                                            <div className="d-flex gap-1 flex-wrap" style={{ maxWidth: 150 }}>
                                                                                <Button variant="outline-success" size="sm" style={{ padding: '2px 6px', fontSize: '0.75rem' }} onClick={() => handleOpenWhatsAppModal(cliente)} disabled={!phone} title="WhatsApp">📱</Button>
                                                                                <Button variant="outline-info" size="sm" style={{ padding: '2px 6px', fontSize: '0.75rem' }} onClick={() => handleOpenTemplates(cliente)} title="Templates">📝</Button>
                                                                                <Button variant="outline-primary" size="sm" style={{ padding: '2px 6px', fontSize: '0.75rem' }} onClick={() => handleOpenEmailModal(cliente)} disabled={!cliente.email} title={cliente.email || 'Sem email'}>📧</Button>
                                                                                <Button variant="outline-secondary" size="sm" style={{ padding: '2px 6px', fontSize: '0.75rem' }} onClick={() => handleCopyLinkShort(cliente)} title="Copiar Link">🔗</Button>
                                                                                <Button variant="outline-dark" size="sm" style={{ padding: '2px 6px', fontSize: '0.75rem' }} onClick={() => { setClienteParaLink(cliente); setShowLinkModal(true); }} title="Gerar Link Rastreável">🎯</Button>
                                                                            </div>
                                                                        );
                                                                    })()}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>

                                                {totalPages > 1 && (
                                                    <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
                                                        <div className="text-muted small">
                                                            Mostrando {startIndex + 1}–{Math.min(startIndex + pageSize, clientesProcessados.length)} de {clientesProcessados.length}
                                                        </div>
                                                        <Pagination className="mb-0">
                                                            <Pagination.Prev
                                                                onClick={() => setPage(Math.max(1, pageSafe - 1))}
                                                                disabled={pageSafe <= 1}
                                                            />
                                                            {Array.from({ length: totalPages }, (_, i) => i + 1)
                                                                .filter((p) => p === 1 || p === totalPages || Math.abs(p - pageSafe) <= 2)
                                                                .reduce((acc, p, idx, arr) => {
                                                                    if (idx > 0 && p - arr[idx - 1] > 1) acc.push('ellipsis-' + p);
                                                                    acc.push(p);
                                                                    return acc;
                                                                }, [])
                                                                .map((p) => {
                                                                    if (typeof p === 'string') {
                                                                        return <Pagination.Ellipsis key={p} disabled />;
                                                                    }
                                                                    return (
                                                                        <Pagination.Item
                                                                            key={p}
                                                                            active={p === pageSafe}
                                                                            onClick={() => setPage(p)}
                                                                        >
                                                                            {p}
                                                                        </Pagination.Item>
                                                                    );
                                                                })}
                                                            <Pagination.Next
                                                                onClick={() => setPage(Math.min(totalPages, pageSafe + 1))}
                                                                disabled={pageSafe >= totalPages}
                                                            />
                                                        </Pagination>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </Tab>

                        {/* ===== WhatsApp Inbox ===== */}
                        <Tab eventKey="whatsapp" title="📱 WhatsApp">
                            <div className="pt-3">
                                <InboxTab onRefreshStats={fetchWaStats} />
                            </div>
                        </Tab>

                        {/* ===== Campanhas Unificadas ===== */}
                        <Tab eventKey="campanhas" title="🚀 Campanhas">
                            <div className="pt-2">
                                {/* Sub-tabs: Win-Back campaigns + WhatsApp campaigns */}
                                <Tabs defaultActiveKey="campanhas-wb" className="mb-3" variant="pills">
                                    <Tab eventKey="campanhas-wb" title="📋 Campanhas Win-Back">
                                        <div className="pt-2">
                                            <Row className="mb-3">
                                                <Col md={8}>
                                                    <h5 className="mb-0 text-secondary">
                                                        Histórico de Campanhas
                                                    </h5>
                                                    <small className="text-muted">
                                                        Visualize e gerencie todas as campanhas de recuperação criadas.
                                                    </small>
                                                </Col>
                                                <Col md={4} className="text-md-end">
                                                    <Button
                                                        variant="secondary"
                                                        size="sm"
                                                        onClick={carregarCampanhas}
                                                        disabled={loadingCampanhas}
                                                    >
                                                        Atualizar Lista
                                                    </Button>
                                                </Col>
                                            </Row>

                                            {loadingCampanhas ? (
                                                <div className="text-center py-5">
                                                    <Spinner animation="border" variant="primary" />
                                                    <p className="mt-2 text-muted">Carregando campanhas...</p>
                                                </div>
                                            ) : (
                                                <>
                                                    {!campanhas || campanhas.length === 0 ? (
                                                        <Alert variant="light" className="text-center border py-5">
                                                            <div className="fs-1 mb-3">📭</div>
                                                            <h5>Nenhuma campanha encontrada</h5>
                                                            <p className="text-muted">Crie sua primeira campanha selecionando clientes na aba "Recuperação".</p>
                                                        </Alert>
                                                    ) : (
                                                        <div className="table-responsive">
                                                            <Table hover className="align-middle table-modern bg-white">
                                                                <thead className="bg-light">
                                                                    <tr>
                                                                        <th>Campanha</th>
                                                                        <th>Tipo</th>
                                                                        <th>Data Criação</th>
                                                                        <th className="text-center">Clientes Alvo</th>
                                                                        <th className="text-center">Status</th>
                                                                        <th className="text-end">Ações</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {campanhas.map((campanha) => (
                                                                        <tr key={campanha.id}>
                                                                            <td>
                                                                                <div className="fw-bold text-primary">{campanha.nome}</div>
                                                                                <small className="text-muted">{campanha.descricao || 'Sem descrição'}</small>
                                                                            </td>
                                                                            <td>
                                                                                {campanha.tipo === 'whatsapp' ? (
                                                                                    <Badge bg="success">📱 WhatsApp</Badge>
                                                                                ) : (
                                                                                    <Badge bg="secondary">🔗 Link</Badge>
                                                                                )}
                                                                            </td>
                                                                            <td>
                                                                                {new Date(campanha.data_criacao).toLocaleString('pt-BR')}
                                                                            </td>
                                                                            <td className="text-center">
                                                                                <Badge bg="info" className="fs-6">
                                                                                    {campanha.total_clientes} clientes
                                                                                </Badge>
                                                                                {campanha.tipo === 'whatsapp' && campanha.sent_count > 0 && (
                                                                                    <div className="mt-1">
                                                                                        <small className="text-muted">
                                                                                            ✉️ {campanha.sent_count} env · ✅ {campanha.delivered_count} ent · 👁️ {campanha.read_count} lid
                                                                                        </small>
                                                                                    </div>
                                                                                )}
                                                                            </td>
                                                                            <td className="text-center">
                                                                                {campanha.tipo === 'whatsapp' ? (
                                                                                    <Badge bg={
                                                                                        campanha.status === 'done' ? 'success' :
                                                                                            campanha.status === 'running' ? 'primary' :
                                                                                                campanha.status === 'paused' ? 'warning' :
                                                                                                    campanha.status === 'cancelled' ? 'danger' : 'secondary'
                                                                                    }>
                                                                                        {campanha.status === 'done' ? 'Concluída' :
                                                                                            campanha.status === 'running' ? 'Enviando...' :
                                                                                                campanha.status === 'paused' ? 'Pausada' :
                                                                                                    campanha.status === 'cancelled' ? 'Cancelada' : 'Rascunho'}
                                                                                    </Badge>
                                                                                ) : (
                                                                                    <Badge bg="success">Ativa</Badge>
                                                                                )}
                                                                            </td>
                                                                            <td className="text-end">
                                                                                <div className="d-flex justify-content-end gap-2">
                                                                                    <Button
                                                                                        variant="outline-primary"
                                                                                        size="sm"
                                                                                        onClick={() => navigate(`/dashboard/campanhas/${campanha.id}`)}
                                                                                    >
                                                                                        Ver Detalhes 📊
                                                                                    </Button>
                                                                                    <Button
                                                                                        variant="outline-danger"
                                                                                        size="sm"
                                                                                        onClick={() => handleDeleteCampaignClick(campanha)}
                                                                                    >
                                                                                        🗑️
                                                                                    </Button>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </Tab>
                                    <Tab eventKey="campanhas-wa" title="📢 Campanhas WhatsApp">
                                        <div className="pt-2">
                                            <WACampanhasTab />
                                        </div>
                                    </Tab>
                                </Tabs>
                            </div>
                        </Tab>

                        {/* ===== Templates ===== */}
                        <Tab eventKey="templates" title="📝 Templates">
                            <div className="pt-3">
                                <TemplatesTab />
                            </div>
                        </Tab>

                        {/* ===== Funil de Feedback ===== */}
                        <Tab eventKey="funil" title="📊 Funil de Feedback">
                            <div className="pt-3">
                                <Row className="mb-3 align-items-center">
                                    <Col md={8}>
                                        <h5 className="mb-0 text-secondary">
                                            🎯 Funil de Feedback de Clientes
                                        </h5>
                                        <small className="text-muted">
                                            Registre os resultados das ligações e acompanhe as métricas de recuperação
                                        </small>
                                    </Col>
                                    <Col md={4} className="text-md-end">
                                        <Button
                                            variant="primary"
                                            size="sm"
                                            onClick={() => setShowDistribuirModal(true)}
                                        >
                                            📤 Distribuir Clientes
                                        </Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={5}>
                                        <FunilFeedback />
                                    </Col>
                                    <Col lg={7}>
                                        <ListaPendentes onFeedbackRegistrado={() => { }} />
                                    </Col>
                                </Row>
                            </div>
                        </Tab>

                        {/* ===== Analytics (Merge: Google + UTM) ===== */}
                        <Tab eventKey="analytics" title="📈 Analytics">
                            <div className="pt-3">
                                <Tabs defaultActiveKey="ga" className="mb-3" variant="pills">
                                    <Tab eventKey="ga" title="📊 Google Analytics">
                                        <AnalyticsTab />
                                    </Tab>
                                    <Tab eventKey="utm" title="📈 Dashboard UTM">
                                        <WinBackDashboard />
                                    </Tab>
                                </Tabs>
                            </div>
                        </Tab>

                        {/* ===== Links & Conversões (Merge) ===== */}
                        <Tab eventKey="links" title="🔗 Links & Conversões">
                            <div className="pt-3">
                                <Tabs defaultActiveKey="links-tab" className="mb-3" variant="pills">
                                    <Tab eventKey="links-tab" title="🔗 Links Rastreáveis">
                                        <div className="pt-2">
                                            <Row className="mb-3">
                                                <Col>
                                                    <h5 className="mb-0 text-secondary">
                                                        Links Personalizados
                                                    </h5>
                                                    <small className="text-muted">
                                                        Gere links rastreáveis para enviar aos clientes e acompanhe cliques, carrinho e compras
                                                    </small>
                                                </Col>
                                            </Row>
                                            <LinksRastreaveis />
                                        </div>
                                    </Tab>
                                    <Tab eventKey="conversoes-tab" title="📊 Conversões">
                                        <div className="pt-2">
                                            <Row className="mb-3">
                                                <Col>
                                                    <h5 className="mb-0 text-secondary">
                                                        Tracking de Conversões
                                                    </h5>
                                                    <small className="text-muted">
                                                        Acompanhe os resultados das suas campanhas de recuperação
                                                    </small>
                                                </Col>
                                            </Row>
                                            <ConversionTracker />
                                        </div>
                                    </Tab>
                                </Tabs>
                            </div>
                        </Tab>

                        {/* ===== Opt-Out / Logs ===== */}
                        <Tab eventKey="optout" title="🚫 Opt-Out">
                            <div className="pt-3">
                                <OptOutTab />
                            </div>
                        </Tab>
                    </Tabs>
                </Card.Body>
            </Card>

            <ClientHistoryModal
                show={showModal}
                onHide={() => {
                    console.log('ClientHistoryModal onHide called');
                    setShowModal(false);
                    setSelectedCliente(null);
                    setHistorico(null);
                }}
                cliente={selectedCliente}
                historico={historico}
                loading={loadingHistorico}
            />

            <WinBackStatsModal
                show={showStatsModal}
                onHide={() => setShowStatsModal(false)}
                stats={statsData}
                loading={loadingStats}
            />

            {/* Modal de Pedidos do Cliente */}
            <Modal show={showPedidosModal} onHide={() => { setShowPedidosModal(false); setPedidosModalData(null); setExpandedPedido(null); }} centered size="lg">
                <Modal.Header closeButton style={{ background: '#1a1d23', borderBottom: '1px solid #2d3748' }}>
                    <Modal.Title style={{ color: '#e2e8f0', fontSize: '1rem' }}>
                        Pedidos de {pedidosModalNome}
                        {pedidosModalData && <Badge bg="info" className="ms-2">{pedidosModalData.total} pedidos</Badge>}
                        <Badge bg={origemDados === 'ecommerce' ? 'warning' : origemDados === 'centro' ? 'primary' : 'success'} text="dark" className="ms-2" style={{ fontSize: '0.7rem' }}>
                            {origemDados === 'ecommerce' ? 'E-commerce' : origemDados === 'centro' ? 'Loja Centro' : 'Loja Caxias'}
                        </Badge>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ background: '#1a1d23', maxHeight: '60vh', overflowY: 'auto' }}>
                    {pedidosModalLoading ? (
                        <div className="text-center py-4"><Spinner animation="border" size="sm" /> Carregando...</div>
                    ) : pedidosModalData?.pedidos?.length > 0 ? (
                        <Table hover size="sm" variant="dark" className="mb-0">
                            <thead>
                                <tr>
                                    <th style={{ width: 30 }}></th>
                                    <th>Cupom/Boleta</th>
                                    <th>Data</th>
                                    <th className="text-center">Itens</th>
                                    <th>Valor Total</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {pedidosModalData.pedidos.map((p, i) => (
                                    <React.Fragment key={i}>
                                        <tr
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => setExpandedPedido(expandedPedido === i ? null : i)}
                                            className={expandedPedido === i ? 'table-active' : ''}
                                        >
                                            <td>{expandedPedido === i ? '▼' : '▶'}</td>
                                            <td><span className="text-info">#{p.id}</span></td>
                                            <td>{p.data ? new Date(p.data).toLocaleDateString('pt-BR') : '-'}</td>
                                            <td className="text-center">{p.itens_count || 0} itens</td>
                                            <td className="fw-bold">R$ {(Number(p.total) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                                            <td><Badge bg={p.status === 'Cancelado' ? 'danger' : p.status === 'Atendido' || p.status === 'Concluído' ? 'success' : 'secondary'}>{p.status || 'N/A'}</Badge></td>
                                        </tr>
                                        {expandedPedido === i && p.itens && p.itens.length > 0 && (
                                            <tr>
                                                <td colSpan="6" style={{ padding: 0, background: '#141720' }}>
                                                    <Table size="sm" variant="dark" className="mb-0" style={{ background: '#141720' }}>
                                                        <thead>
                                                            <tr style={{ fontSize: '0.75rem', color: '#94a3b8' }}>
                                                                <th style={{ paddingLeft: 40 }}>Produto</th>
                                                                <th>Código</th>
                                                                <th className="text-center">Qtd</th>
                                                                <th>Valor Unit.</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {p.itens.map((item, j) => (
                                                                <tr key={j} style={{ fontSize: '0.8rem' }}>
                                                                    <td style={{ paddingLeft: 40 }}>{item.descricao || '-'}</td>
                                                                    <td className="text-muted">{item.codigo || '-'}</td>
                                                                    <td className="text-center"><Badge bg="light" text="dark">{item.quantidade || 1}</Badge></td>
                                                                    <td>R$ {(Number(item.valor_unitario) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                        <Alert variant="info" className="text-center mb-0">Nenhum pedido encontrado.</Alert>
                    )}
                </Modal.Body>
                <Modal.Footer style={{ background: '#1a1d23', borderTop: '1px solid #2d3748' }}>
                    <Button variant="secondary" size="sm" onClick={() => { setShowPedidosModal(false); setPedidosModalData(null); setExpandedPedido(null); }}>Fechar</Button>
                </Modal.Footer>
            </Modal>

            <CreateCampaignModal
                show={showCreateCampaignModal}
                onHide={() => setShowCreateCampaignModal(false)}
                selectedIds={selectedIds}
            />

            {/* Modal de Templates de Mensagens */}
            <MessageTemplates
                show={showTemplatesModal}
                onHide={() => {
                    setShowTemplatesModal(false);
                    setTemplateCliente(null);
                }}
                cliente={templateCliente}
                onSendMessage={handleTemplateSent}
            />

            {/* Modal de Distribuição de Clientes */}
            <DistribuirClientes
                show={showDistribuirModal}
                onHide={() => setShowDistribuirModal(false)}
                clientes={clientesProcessados}
                segmentoAtivo={segmentoAtivo}
            />

            {/* Modal de Geração de Link Rastreável */}
            <LinkGenerator
                show={showLinkModal}
                onHide={() => {
                    setShowLinkModal(false);
                    setClienteParaLink(null);
                }}
                cliente={clienteParaLink}
            />

            {/* Modal de confirmação para deletar campanha */}
            <Modal show={showDeleteCampaignModal} onHide={() => setShowDeleteCampaignModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>⚠️ Cancelar Campanha</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Tem certeza que deseja cancelar a campanha <strong>"{campaignToDelete?.nome}"</strong>?</p>
                    <p className="text-muted small">
                        Esta ação irá remover a campanha e todos os links gerados.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteCampaignModal(false)} disabled={deletingCampaign}>
                        Voltar
                    </Button>
                    <Button variant="danger" onClick={handleConfirmDeleteCampaign} disabled={deletingCampaign}>
                        {deletingCampaign ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Cancelando...
                            </>
                        ) : (
                            '🗑️ Sim, Cancelar'
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Envio WhatsApp Personalizado */}
            <Modal show={showWhatsAppModal} onHide={() => setShowWhatsAppModal(false)} centered size="lg">
                <Modal.Header closeButton className="bg-success text-white">
                    <Modal.Title>📱 Enviar WhatsApp Direto</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">Telefone</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Ex: 21999998888"
                            value={whatsAppForm.telefone}
                            onChange={(e) => setWhatsAppForm(prev => ({ ...prev, telefone: e.target.value.replace(/\D/g, '') }))}
                        />
                        <Form.Text className="text-muted">DDD + número, apenas números</Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">Nome do contato (opcional)</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Nome do cliente"
                            value={whatsAppForm.contato_nome}
                            onChange={(e) => setWhatsAppForm(prev => ({ ...prev, contato_nome: e.target.value }))}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">Mensagem</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={5}
                            placeholder="Digite sua mensagem aqui..."
                            value={whatsAppForm.mensagem}
                            onChange={(e) => setWhatsAppForm(prev => ({ ...prev, mensagem: e.target.value }))}
                        />
                        <Form.Text className="text-muted">{whatsAppForm.mensagem.length} caracteres</Form.Text>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowWhatsAppModal(false)}>
                        Cancelar
                    </Button>
                    <Button
                        variant="success"
                        onClick={handleSendWhatsAppFromModal}
                        disabled={sendingWhatsApp === 'modal' || !whatsAppForm.telefone || !whatsAppForm.mensagem.trim()}
                    >
                        {sendingWhatsApp === 'modal' ? (
                            <><Spinner size="sm" animation="border" className="me-2" />Enviando...</>
                        ) : (
                            '📱 Enviar Mensagem'
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Envio de Email Win-Back */}
            <Modal show={showEmailModal} onHide={() => setShowEmailModal(false)} centered size="xl" dialogClassName="modal-90w">
                <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0d6efd 0%, #0b5ed7 100%)' }} className="text-white">
                    <Modal.Title>📧 Enviar Email Win-Back</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto' }}>
                    <div className="mb-3 p-3" style={{ background: 'linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%)', borderRadius: 10, border: '1px solid #28a745' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <span style={{ fontSize: '1.5rem' }}>✅</span>
                            <div>
                                <div style={{ fontWeight: 700, color: '#155724', fontSize: '0.95rem' }}>Email vinculado automaticamente</div>
                                <div style={{ color: '#155724', fontSize: '0.85rem' }}>
                                    📤 Remetente: <strong>marketing@lojagringao.com.br</strong> (Google Workspace)
                                </div>
                            </div>
                        </div>
                    </div>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">📥 Email Destinatário</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="cliente@email.com"
                            value={emailForm.destinatario}
                            onChange={(e) => setEmailForm(prev => ({ ...prev, destinatario: e.target.value }))}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">📋 Assunto</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Assunto do email"
                            value={emailForm.assunto}
                            onChange={(e) => setEmailForm(prev => ({ ...prev, assunto: e.target.value }))}
                        />
                    </Form.Group>

                    {/* ===== SELETOR DE LAYOUT ===== */}
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">🎨 Escolha o Layout do Email</Form.Label>
                        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                            {Object.entries(EMAIL_LAYOUTS).map(([key, cfg]) => (
                                <div
                                    key={key}
                                    onClick={() => {
                                        setEmailLayout(key);
                                        regenerarEmailHtml(key, emailProdutos);
                                    }}
                                    style={{
                                        flex: '1 1 130px',
                                        minWidth: 130,
                                        padding: '14px 12px',
                                        borderRadius: 10,
                                        border: emailLayout === key ? '2px solid #0d6efd' : '2px solid #e0e0e0',
                                        background: emailLayout === key ? '#e8f0fe' : '#fafafa',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'all 0.2s',
                                        boxShadow: emailLayout === key ? '0 2px 8px rgba(13,110,253,0.15)' : 'none'
                                    }}
                                >
                                    <div style={{ fontSize: '1.3rem', marginBottom: 4 }}>{cfg.label.split(' ')[0]}</div>
                                    <div style={{ fontWeight: 700, fontSize: '0.82rem', color: emailLayout === key ? '#0d6efd' : '#333' }}>
                                        {cfg.label.substring(cfg.label.indexOf(' ') + 1)}
                                    </div>
                                    <div style={{ fontSize: '0.7rem', color: '#888', marginTop: 2 }}>{cfg.desc}</div>
                                </div>
                            ))}
                        </div>
                    </Form.Group>

                    {/* ===== CAMPOS DE PRODUTOS COM FOTOS ===== */}
                    <Form.Group className="mb-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <Form.Label className="fw-bold mb-0">📸 Produtos (nome, foto e link)</Form.Label>
                            <small className="text-muted">Cole URLs de imagens reais dos produtos</small>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: emailLayout === 'destaque' || emailLayout === 'winback' ? '1fr' : '1fr 1fr', gap: 10 }}>
                            {emailProdutos.map((prod, idx) => {
                                // No layout destaque/winback, mostrar apenas 1 produto
                                if ((emailLayout === 'destaque' || emailLayout === 'winback') && idx > 0) return null;
                                return (
                                    <div key={idx} style={{
                                        border: '1px solid #e0e0e0', borderRadius: 8, padding: 10, background: '#fafafa'
                                    }}>
                                        <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                                            {/* Preview da imagem */}
                                            <div style={{
                                                width: 70, height: 70, borderRadius: 6, overflow: 'hidden',
                                                border: '1px solid #ddd', background: '#fff', flexShrink: 0,
                                                display: 'flex', alignItems: 'center', justifyContent: 'center'
                                            }}>
                                                {prod.imagem ? (
                                                    <img
                                                        src={prod.imagem}
                                                        alt={prod.nome}
                                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                        onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block'; }}
                                                    />
                                                ) : null}
                                                <span style={{
                                                    fontSize: '0.7rem', color: '#aaa', textAlign: 'center', padding: 4,
                                                    display: prod.imagem ? 'none' : 'block'
                                                }}>Sem foto</span>
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <Form.Control
                                                    size="sm"
                                                    type="text"
                                                    placeholder={`Nome do produto ${idx + 1}`}
                                                    value={prod.nome}
                                                    onChange={(e) => {
                                                        const atualizado = [...emailProdutos];
                                                        atualizado[idx] = { ...atualizado[idx], nome: e.target.value };
                                                        setEmailProdutos(atualizado);
                                                    }}
                                                    className="mb-1"
                                                />
                                                <Form.Control
                                                    size="sm"
                                                    type="url"
                                                    placeholder="URL da foto (https://...)"
                                                    value={prod.imagem}
                                                    onChange={(e) => {
                                                        const atualizado = [...emailProdutos];
                                                        atualizado[idx] = { ...atualizado[idx], imagem: e.target.value };
                                                        setEmailProdutos(atualizado);
                                                    }}
                                                    className="mb-1"
                                                />
                                                <Form.Control
                                                    size="sm"
                                                    type="url"
                                                    placeholder="Link do produto (https://...)"
                                                    value={prod.link}
                                                    onChange={(e) => {
                                                        const atualizado = [...emailProdutos];
                                                        atualizado[idx] = { ...atualizado[idx], link: e.target.value };
                                                        setEmailProdutos(atualizado);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div className="text-end mt-2">
                            <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => regenerarEmailHtml(emailLayout, emailProdutos)}
                            >
                                🔄 Atualizar HTML com estes dados
                            </Button>
                        </div>
                    </Form.Group>

                    {/* ===== EDITOR/PREVIEW HTML ===== */}
                    <Form.Group className="mb-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <Form.Label className="fw-bold mb-0">✏️ Corpo do Email (HTML)</Form.Label>
                            <Button
                                variant={emailPreview ? 'outline-secondary' : 'outline-info'}
                                size="sm"
                                onClick={() => setEmailPreview(!emailPreview)}
                            >
                                {emailPreview ? '✏️ Editar' : '👁️ Preview'}
                            </Button>
                        </div>
                        {emailPreview ? (
                            <div
                                style={{
                                    border: '1px solid #dee2e6',
                                    borderRadius: 8,
                                    padding: 16,
                                    maxHeight: 500,
                                    overflow: 'auto',
                                    background: '#fff'
                                }}
                                dangerouslySetInnerHTML={{ __html: emailForm.htmlBody }}
                            />
                        ) : (
                            <Form.Control
                                as="textarea"
                                rows={12}
                                placeholder="Cole ou edite seu HTML aqui..."
                                value={emailForm.htmlBody}
                                onChange={(e) => setEmailForm(prev => ({ ...prev, htmlBody: e.target.value }))}
                                style={{ fontFamily: 'monospace', fontSize: '0.85rem' }}
                            />
                        )}
                        <Form.Text className="text-muted">
                            O email deve ser em HTML. Use o botão Preview para visualizar antes de enviar.
                        </Form.Text>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEmailModal(false)}>
                        Cancelar
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleSendEmail}
                        disabled={sendingEmail || !emailForm.destinatario || !emailForm.assunto.trim()}
                    >
                        {sendingEmail ? (
                            <><Spinner size="sm" animation="border" className="me-2" />Enviando...</>
                        ) : (
                            '📧 Enviar Email'
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Exportação CSV — Seleção de Colunas */}
            <Modal show={showExportModal} onHide={() => setShowExportModal(false)} centered>
                <Modal.Header closeButton style={{ background: '#f8f9fa' }}>
                    <Modal.Title style={{ fontSize: '1.1rem' }}>
                        📥 Exportar CSV — Escolha os dados
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="text-muted mb-3" style={{ fontSize: '0.9rem' }}>
                        {exportMode === 'selecionados'
                            ? `Exportando ${selectedIds.length} clientes selecionados`
                            : `Exportando ${clientesProcessados.length} clientes`
                        }. Marque as colunas que deseja incluir:
                    </p>
                    <div className="d-flex gap-2 mb-3">
                        <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => setExportColunas({
                                cliente: true, telefone: true, email: true,
                                dias_sem_comprar: true, cidade_uf: true,
                                ultima_compra: true, total_gasto: true, pedidos: true
                            })}
                        >
                            ✅ Selecionar Tudo
                        </Button>
                        <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => setExportColunas({
                                cliente: false, telefone: false, email: false,
                                dias_sem_comprar: false, cidade_uf: false,
                                ultima_compra: false, total_gasto: false, pedidos: false
                            })}
                        >
                            Limpar Tudo
                        </Button>
                    </div>
                    {[
                        { key: 'cliente', label: '👤 Cliente (Nome)' },
                        { key: 'telefone', label: '📱 Telefone' },
                        { key: 'email', label: '📧 Email' },
                        { key: 'dias_sem_comprar', label: '📅 Dias sem comprar' },
                        { key: 'cidade_uf', label: '📍 Cidade/UF' },
                        { key: 'ultima_compra', label: '🛒 Última compra' },
                        { key: 'total_gasto', label: '💰 Total gasto' },
                        { key: 'pedidos', label: '📦 Pedidos' }
                    ].map(col => (
                        <Form.Check
                            key={col.key}
                            type="checkbox"
                            id={`export-col-${col.key}`}
                            label={col.label}
                            checked={exportColunas[col.key]}
                            onChange={() => toggleExportColuna(col.key)}
                            className="mb-2"
                            style={{ fontSize: '0.95rem' }}
                        />
                    ))}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowExportModal(false)}>
                        Cancelar
                    </Button>
                    <Button
                        variant="success"
                        onClick={executarExportCSV}
                        disabled={!Object.values(exportColunas).some(v => v)}
                    >
                        📥 Exportar CSV
                    </Button>
                </Modal.Footer>
            </Modal>

            <ToastContainer className="p-3" position="top-end">
                <Toast
                    onClose={() => setToastState({ ...toastState, show: false })}
                    show={toastState.show}
                    delay={3000}
                    autohide
                    bg={toastState.bg}
                >
                    <Toast.Header>
                        <strong className="me-auto">Sistema</strong>
                    </Toast.Header>
                    <Toast.Body className={toastState.bg === 'danger' ? 'text-white' : ''}>
                        {toastState.message}
                    </Toast.Body>
                </Toast>
            </ToastContainer>
        </div>
    );
};

export default ClientesInativos;
